<template>
  <!-- 绑定邮箱-->
  <div class="view-box">
    <navBan title="绑定邮箱"></navBan>
    <div class="input-box" style="margin-top: 32px">
      <img class="icon" src="../../assets/images/mobile/Mail.svg" alt="">
      <input v-model="email" placeholder="请输入要绑定的邮箱" type="text">
    </div>

    <button @click="submitForm" class="button" :class="{ 'button-disabled': email==='' }" :disabled="email===''">确认绑定</button>
  </div>
</template>

<script>
import navBan from '@/components/navBan';

export default {
  name: 'bindEmail',
  components: { navBan },
  data () {
    return {
      email: ''
    };
  },
  created () {},
  methods: {
    submitForm () {}
  }
};
</script>

<style lang="scss" scoped>
</style>
